"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var Button_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Button"));
var react_1 = tslib_1.__importDefault(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("../../../theme/styled-components"));
var utilities_1 = require("../../../utilities/utilities");
var TimerText = styled_components_1["default"].span(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.color.fadedText;
});
var RefreshButton = function (_a) {
    var className = _a.className, disabled = _a.disabled, interval = _a.interval, onTimeout = _a.onTimeout;
    var _b = react_1["default"].useState(1), value = _b[0], setValue = _b[1];
    // main timer counter
    var timerRef = react_1["default"].useRef();
    react_1["default"].useEffect(function () {
        if (timerRef.current) {
            window.clearInterval(timerRef.current);
        }
        if (disabled) {
            setValue(1);
            return;
        }
        // every `interval` seconds fires event
        if (interval - value < 0) {
            onTimeout();
            setValue(1);
        }
        var decrease = function () {
            setValue(function (prev) {
                return ++prev;
            });
        };
        timerRef.current = window.setTimeout(decrease, 1000);
        return function () {
            if (timerRef.current) {
                window.clearInterval(timerRef.current);
            }
        };
    }, [interval, setValue, onTimeout, value, disabled]);
    var handleClick = function () {
        setValue(1);
        onTimeout();
    };
    return (react_1["default"].createElement(Button_1["default"], { className: className, block: true, basic: true, primary: true, onClick: handleClick, disabled: disabled, title: utilities_1.__('Zápas sa aktualizuje automaticky, alebo po stlačení tlačidla.') },
        utilities_1.__('Aktualizuj'),
        react_1["default"].createElement(TimerText, null,
            "\u00A0-\u00A0automaticky\u00A0o\u00A0",
            interval - value,
            "s")));
};
exports["default"] = RefreshButton;
var templateObject_1;
